import React from 'react';
import { Link } from './styled';
import { FormHeader } from './basic/FormHeader';
import { CengagePhoneHelp } from './basic/links/CengagePhoneHelp';

export const TEST_ID = {
  INSTRUCTIONS: 'error-instructions'
};

interface ErrorContentProps {
  msg?: string | React.ReactNode;
}

export const ErrorContent: React.FunctionComponent<ErrorContentProps> = (
  props: ErrorContentProps
) => {
  const { msg = 'There was an unexpected error.' } = props;
  return (
    <React.Fragment>
      <FormHeader>Sorry!</FormHeader>
      <div
        style={{
          marginTop: '20px',
          marginBottom: '20px',
          textAlign: 'center'
        }}
        data-testid={TEST_ID.INSTRUCTIONS}
      >
        <p>{msg}</p>
        <p>
          If you need further assistance please <CengagePhoneHelp />.
        </p>
        <p>Thank you for your patience as we get this sorted out.</p>
        <p>
          <Link href="/">return to homepage</Link>
        </p>
      </div>
    </React.Fragment>
  );
};
